import LinkRootBlocks from '../../../components/blocks/LinkRootBlocks.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function LinkrootUser() {
    return (
        <LinkRootBlocks
            maintitle="¿Qué acción deseas realizar?"
            columnsPerRow={3}
            blocks={[
                { ico: "bi bi-person-fill-add", title: "Crear un nuevo usuario", link: ROUTES.CREATEUSER},
                { ico: "bi bi-person-lines-fill", title: "Examinar lista de usuarios", link: ROUTES.LISTUSER},
                { ico: "bi bi-person-fill-gear", title: "Administradores del sitio", link: ROUTES.ADMINS}
            ]}
        />
    );
}